<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="admin-list-manager-title">
                {{ $t('admin.list_manager.list.title') }}
            </div>
            <a-dropdown :trigger="['click']" class="shadow-none" data-cy="admin-list-manager-import-export-dropdown">
                <a-button style="margin-left: 8px">
                    {{ $t('admin.list_manager.table.buttons.actions.title') }}<DownOutlined />
                </a-button>
                <template #overlay>
                    <a-menu @click="onSelectClick">
                        <a-menu-item data-cy="admin-list-manager-import-select" key="Import">
                            <UploadOutlined />
                            {{ $t('admin.list_manager.table.buttons.actions.upload') }}
                        </a-menu-item>
                        <a-menu-item data-cy="admin-list-manager-export-select" key="Export">
                            <DownloadOutlined />
                            {{ $t('admin.list_manager.table.buttons.actions.download') }}
                        </a-menu-item>
                        <a-menu-item data-cy="admin-list-manager-update-cb-categories" key="UpdateCBCategories">
                            <RedoOutlined />
                            {{ $t('admin.list_manager.table.buttons.actions.update_unknown_cb_categories') }}
                        </a-menu-item>
                        <a-menu-item data-cy="admin-list-manager-update-cb-vehicles" key="UpdateCBVehicles">
                            <RedoOutlined />
                            {{ $t('admin.list_manager.table.buttons.actions.update_unknown_cb_vehicles') }}
                        </a-menu-item>
                        <a-menu-item
                            data-cy="admin-list-manager-update-claim-status-categories"
                            key="UpdateClaimStatusCategories"
                        >
                            <RedoOutlined />
                            {{ $t('admin.list_manager.table.buttons.actions.update_unknown_claim_status_categories') }}
                        </a-menu-item>
                        <a-menu-item data-cy="admin-list-manager-update-settlement-types" key="UpdateSettlementTypes">
                            <RedoOutlined />
                            {{ $t('admin.list_manager.table.buttons.actions.update_unknown_settlement_types') }}
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
        </div>
        <list-manager-table
            ref="ListManagerTable"
            @is-form-dirty="isFormDirty"
            :selected_row_keys="selected_row_keys"
            @onSelectChange="onSelectChange"
            @onTableAction="onTableAction"
        />
        <a-drawer
            data-cy="list-manager-drawer"
            :title="$t('admin.list_manager.drawer.title')"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onDrawerClose"
        >
            <form-list-manager-item
                :list_manager_item="list_manager_item"
                :processing="processing"
                :validation="validation"
                @is-form-dirty="isFormDirty"
                @formSubmit="onSave"
                @onDrawerClose="onDrawerClose"
            />
        </a-drawer>
        <modal-import-data @formSubmit="onImport" :processing="processing" ref="ImportDataModal" />
        <modal-export-data @formSubmit="onExport" :processing="processing" ref="ExportDataModal" />
        <modal-update-cb-vehicles
            @formSubmit="onUpdateCBVehicles"
            :processing="processing"
            ref="UpdateCBVehiclesModal"
        />
        <modal-update-cb-categories
            @formSubmit="onUpdateCBCategories"
            :processing="processing"
            ref="UpdateCBCategoriesModal"
        />
        <modal-update-claim-status-categories
            @formSubmit="onUpdateClaimStatusCategories"
            :processing="processing"
            ref="UpdateClaimStatusCategoriesModal"
        />
        <modal-update-settlement-types
            @formSubmit="onUpdateSettlementTypes"
            :processing="processing"
            ref="UpdateSettlementTypesModal"
        />
    </div>
</template>

<script>
import FormListManagerItem from '@/components/forms/ListManagerItem.vue';
import ListManagerTable from '@/components/tables/ListManager.vue';
import ModalImportData from '@/components/modals/ListManagerImportData.vue';
import ModalExportData from '@/components/modals/ListManagerExportData.vue';
import ModalUpdateCbVehicles from '@/components/modals/UpdateCBVehicles.vue';
import ModalUpdateCbCategories from '@/components/modals/UpdateCBCategories.vue';
import ModalUpdateClaimStatusCategories from '@/components/modals/UpdateClaimStatusCategories.vue';
import ModalUpdateSettlementTypes from '@/components/modals/UpdateSettlementTypes.vue';

import FileManager from '@/utils/file';
import { DownloadOutlined, DownOutlined, RedoOutlined, UploadOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        FormListManagerItem,
        ListManagerTable,
        ModalImportData,
        ModalExportData,
        ModalUpdateCbVehicles,
        ModalUpdateCbCategories,
        ModalUpdateClaimStatusCategories,
        ModalUpdateSettlementTypes,
        DownloadOutlined,
        DownOutlined,
        RedoOutlined,
        UploadOutlined,
    },
    props: {
        is_form_dirty: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            drawer_visible: false,
            list_manager_item: {},
            selected_row_keys: [],
            validation: {
                errors: {},
                message: '',
            },
            processing: false,
        };
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        isFormDirty(is_form_dirty) {
            this.$emit('is-form-dirty', is_form_dirty);
        },
        onSelectChange(selected_row_keys) {
            this.selected_row_keys = selected_row_keys;
        },
        onTableAction(data) {
            switch (data.key) {
                case 'edit':
                    this.openDrawer({ id: data.id });
                    break;
            }
        },
        openDrawer(record) {
            if (!_.isEmpty(record) && record.id !== null) {
                const id = record.id;

                this.$http.get('/api/listmanager/' + id).then((response) => {
                    this.list_manager_item = {
                        ...response.data.data,
                        flag_a: response.data.data.flag_a ? true : false,
                        flag_b: response.data.data.flag_b ? true : false,
                        flag_c: response.data.data.flag_c ? true : false,
                        is_active: response.data.data.is_active ? true : false,
                    };

                    this.drawer_visible = true;
                });
            } else {
                this.list_manager_item = {
                    association_id: '',
                    company_id: '',
                    category: '',
                    item: '',
                    value: '',
                    description: '',
                    flag_a: false,
                    flag_b: false,
                    flag_c: false,
                    option_a: '',
                    option_b: '',
                    option_c: '',
                    notes: '',
                    is_active: true,
                };

                this.drawer_visible = true;
            }
        },
        onDrawerClose() {
            let can_close = true;

            if (this.is_form_dirty) {
                let that = this;
                can_close = false;

                this.$confirm({
                    title: this.$t('globals.navigation.notifications.unsaved_changes.title'),
                    content: this.$t('globals.navigation.notifications.unsaved_changes.content'),
                    onOk() {
                        that.isFormDirty(false);
                        that.drawer_visible = false;
                    },
                });
            }

            if (can_close) {
                this.isFormDirty(false);
                this.drawer_visible = false;
            }
        },
        onSave(data) {
            if (this.processing) {
                return false;
            }

            this.processing = true;

            let payload = data;

            if (payload.id == undefined) {
                this.$http
                    .post('/api/listmanager', payload)
                    .then((response) => {
                        this.isFormDirty(false);

                        this.$refs.ListManagerTable.sorter = {
                            field: 'created_at',
                            order: 'descend',
                        };

                        this.$refs.ListManagerTable.reload();

                        this.drawer_visible = false;
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.validation = error.response.data;
                        } else if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVLMIA01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            } else {
                let id = payload.id;

                this.$http
                    .put('/api/listmanager/' + id, payload)
                    .then((response) => {
                        this.isFormDirty(false);

                        this.$refs.ListManagerTable.reload();

                        this.drawer_visible = false;
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.validation = error.response.data;
                        } else if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVLLMIU01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },
        onSelectClick(event) {
            switch (event.key) {
                case 'Import':
                    this.$refs.ImportDataModal.showModal();
                    break;
                case 'Export':
                    this.$refs.ExportDataModal.association_id = null;
                    this.$refs.ExportDataModal.category = undefined;
                    this.$refs.ExportDataModal.showModal();
                    break;
                case 'UpdateCBVehicles':
                    this.$refs.UpdateCBVehiclesModal.showModal();
                    break;
                case 'UpdateCBCategories':
                    this.$refs.UpdateCBCategoriesModal.showModal();
                    break;
                case 'UpdateClaimStatusCategories':
                    this.$refs.UpdateClaimStatusCategoriesModal.showModal();
                    break;
                case 'UpdateSettlementTypes':
                    this.$refs.UpdateSettlementTypesModal.showModal();
                    break;
            }
        },
        onImport(data) {
            if (this.processing) {
                return false;
            }

            this.processing = true;
            const headers = { 'Content-Type': 'multipart/form-data' };

            this.$http
                .post('/api/listmanager/import', data, { headers })
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$refs.ImportDataModal.fileList = [];
                        this.$refs.ListManagerTable.reload();
                        this.$notification.success({ message: response.data.message });
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVLLMIU02' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onExport(data) {
            if (this.processing) {
                return false;
            }

            this.$http
                .post('/api/listmanager/export', { ...data })
                .then((response) => {
                    if (
                        _.includes(
                            [
                                'text/csv; charset=UTF-8',
                                'text/csv; charset=utf-8',
                                'text/plain; charset=UTF-8',
                                'text/plain; charset=utf-8',
                            ],
                            response.headers['content-type'],
                        )
                    ) {
                        this.$notification.success({
                            message: this.$t('admin.list_manager.notifications.success.export'),
                        });

                        FileManager.download(response);
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVLLMIU03' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onUpdateCBVehicles() {
            this.processing = true;

            this.$http
                .post('/api/listmanager/update-claim-cb-vehicles')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$refs.UpdateCBVehiclesModal.hideModal();
                        this.$notification.success({ message: response.data.message });
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVUPCB01' }),
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onUpdateCBCategories() {
            this.processing = true;

            this.$http
                .post('/api/listmanager/update-claim-cb-categories')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$refs.UpdateCBCategoriesModal.hideModal();
                        this.$notification.success({ message: response.data.message });
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVUPCB02' }),
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onUpdateClaimStatusCategories() {
            this.processing = true;

            this.$http
                .post('/api/listmanager/update-claim-status-categories')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$refs.UpdateClaimStatusCategoriesModal.hideModal();
                        this.$notification.success({ message: response.data.message });
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVUPCB03' }),
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onUpdateSettlementTypes() {
            this.processing = true;

            this.$http
                .post('/api/listmanager/update-claim-settlement-types')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$refs.UpdateSettlementTypesModal.hideModal();
                        this.$notification.success({ message: response.data.message });
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVUPCB04' }),
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        reload() {
            this.$refs.ListManagerTable.reload();
        },
    },
};
</script>
